import DriveView from '@/views/DriveView.vue'
import PadelView from '@/views/PadelView.vue'
import { createRouter, createWebHistory, RouteLocation } from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/padel',
    },
    {
        path: '/padel',
        component: PadelView,
        props: (route: RouteLocation) => ({
            framed: !!route.query.framed || false,
            token: route.query.token as string | undefined,
        }),
    },
    {
        path: '/drive',
        component: DriveView,
        props: (route: RouteLocation) => ({ framed: !!route.query.framed || false }),
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
